import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

// OwnerSelector — controls Itinerary.created_by, the agent whose dashboard
// "thread" the trip (and its versions) belongs to. Saved immediately.
export function OwnerSelector({ itn, setField }) {
  const [agents, setAgents] = useState([]);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    api.get("/agents/list", { params: { include_self: true } })
      .then(({ data }) => setAgents(data.agents || []))
      .catch(() => setAgents([]));
  }, []);

  const current = (itn.created_by || "").toLowerCase();
  const selected = agents.find((a) => a.email === current);

  const change = async (email) => {
    if (!email || email === current) return;
    setSaving(true);
    try {
      await api.put(`/itineraries/${itn.itinerary_id}/owner`, { email });
      setField("created_by", email);
      const a = agents.find((x) => x.email === email);
      toast.success(`Propietario cambiado a ${a?.name || email}`);
    } catch (e) { toast.error(e?.response?.data?.detail || "No se pudo cambiar el propietario"); }
    finally { setSaving(false); }
  };

  return (
    <select
      data-testid="owner-agent"
      value={current}
      disabled={saving}
      onChange={(e) => change(e.target.value)}
      className="w-full bg-transparent outline-none text-sm cursor-pointer disabled:opacity-60"
      title="Agente al que pertenece el viaje · las versiones nuevas se quedan con el mismo propietario"
    >
      {current && !selected && <option value={current}>{current}</option>}
      {agents.map((a) => (
        <option key={a.email} value={a.email}>{a.name}</option>
      ))}
    </select>
  );
}
